import React from 'react';
import styles from '../irlObservations2026.module.css';
import { FreshnessBadge } from '../chrome';
import { stripHtmlText } from './shared';

export default function Obs_Review_Obs({ items, irlCount, tab, onTab, onBack, onOpenObs, onAnalyse, onDismiss, busy }) {
    const rows = items || [];
    return (
        <>
            <div className={styles.suggestHead}>
                <div>
                    <button type="button" className={styles.backBtn} onClick={onBack}>
                        ← Observations
                    </button>
                    <h2 className={styles.suggestKicker}>Review affected items</h2>
                    <p className={styles.suggestMeta}>
                        {rows.length + (irlCount || 0)} items may need review · New evidence has become Ready since these records were last reviewed.
                    </p>
                </div>
            </div>
            <div className={styles.tabs}>
                <button type="button" className={`${styles.tab} ${tab === 'IRL Responses' ? styles.tabActive : ''}`} onClick={() => onTab('IRL Responses')}>
                    IRL Responses
                    <span className={styles.tabMutedCount}>{irlCount || 0}</span>
                </button>
                <button type="button" className={`${styles.tab} ${tab === 'Observations' ? styles.tabActive : ''}`} onClick={() => onTab('Observations')}>
                    Observations
                    <span className={styles.tabMutedCount}>{rows.length}</span>
                </button>
            </div>
            <div className={styles.detailBody}>
                {rows.length === 0 && <p className={styles.emptyBody}>No affected observations to review.</p>}
                {rows.map(item => (
                    <div key={item.id} className={styles.reviewCard}>
                        <div className={styles.suggestTitleRow}>
                            <div>
                                <div className={styles.suggestId}>{item.id}</div>
                                <div className={styles.rowTitle}>{stripHtmlText(item.title)}</div>
                            </div>
                            <FreshnessBadge value={item.freshness} />
                        </div>
                        <p className={styles.responseBody}>{item.whatChanged}</p>
                        <div className={styles.actionRow}>
                            <button type="button" className={styles.outlineBtn} onClick={() => onAnalyse?.(item.id)} disabled={busy}>
                                Analyse update
                            </button>
                            <button type="button" className={styles.outlineBtn} onClick={() => onOpenObs(item.id)}>
                                Open Observation
                            </button>
                            <button type="button" className={styles.mutedBtn} onClick={() => onDismiss?.(item.id)} disabled={busy}>
                                Dismiss impact
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}
